import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { fileUrl } from "@/lib/api";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import NotificationBell from "@/components/NotificationBell";
import EditProfileDialog from "@/components/EditProfileDialog";
import { TreeStructure, SignOut, Question } from "@phosphor-icons/react";

export default function TopNav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [editOpen, setEditOpen] = useState(false);
  const initial = user?.name ? user.name.charAt(0).toUpperCase() : "L";

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-30 bg-ivory/90 backdrop-blur-md border-b border-sage" data-testid="top-nav">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <Link to="/dashboard" className="flex items-center gap-2.5 group" data-testid="logo-link">
          <span className="w-9 h-9 rounded-full bg-forest text-gold flex items-center justify-center">
            <TreeStructure size={20} weight="duotone" />
          </span>
          <span className="font-display text-xl text-forest tracking-tight">LegacyLink</span>
        </Link>
        {user && (
          <div className="flex items-center gap-2 sm:gap-3">
            <Link
              to="/help"
              className="w-9 h-9 rounded-full border border-sage text-forest hover:bg-cream flex items-center justify-center transition-colors"
              title="Help & FAQ"
              data-testid="open-help"
            >
              <Question size={18} weight="bold" />
            </Link>
            <NotificationBell />
            <button
              type="button"
              onClick={() => setEditOpen(true)}
              className="flex items-center gap-2 rounded-full pl-2 pr-1 py-1 hover:bg-cream transition-colors"
              data-testid="open-edit-profile"
              title="Edit your profile"
            >
              <span className="hidden sm:block text-sm text-sageGray" data-testid="user-name">{user.name}</span>
              <Avatar className="w-9 h-9 border-2 border-gold/60" data-testid="user-avatar">
                {user.profile_photo_path && <AvatarImage src={fileUrl(user.profile_photo_path)} />}
                <AvatarFallback className="bg-forest text-ivory text-sm">{initial}</AvatarFallback>
              </Avatar>
            </button>
            <Button variant="ghost" size="sm" onClick={handleLogout} className="text-forest hover:bg-cream" data-testid="logout-button">
              <SignOut size={18} className="mr-1.5" /> Sign out
            </Button>
          </div>
        )}
      </div>
      <EditProfileDialog open={editOpen} onOpenChange={setEditOpen} />
    </header>
  );
}
